export const messages = {
    "baseform.actions.button.clean": "Limpiar",
    "baseform.actions.button.save": "Guardar",
    "basecrud.actions.button.edit": "Modificar",
    "basecrud.actions.button.delete": "Eliminar",
    "basecrud.actions.button.new": "Nuevo",
    "basecrud.actions.button.search": "Buscar",
    "basecrud.confirm.delete.title": "Confirmación",
    "basecrud.confirm.save.title.success": "Confirmación",
    "basecrud.confirm.edit.title.success": "Confirmación",
    "basecrud.confirm.delete.success.title": "Confirmación",
    "basecrud.default.msg.title": "Error de validación",
    "confirm.button.yes": "Si",
    "confirm.button.no": "No",
    "basecrud.table.link.next": "Cargar las siguientes ?1 filas",
    "baseservice.msg.default.exception.summary": "Exception",
    "baseservice.msg.default.unauthorized.summary": "Acceso denegado",
    "baseservice.msg.default.unauthorized.detail": "No tiene permisos para realizar esta petición",
    "baseservice.msg.default.error.summary": "Exception",
    "baseservice.msg.default.error.detail": "Ha ocurrido un error al procesar la petición",


    "administration.banner.form.title": "Formulario de banner",
    "administration.banner.form.save.msg.success": "Banner creado correctamente",
    "administration.banner.form.edit.msg.success": "Banner editado correctamente",
    "administration.banner.form.delete.msg.success": "Banner eliminado correctamente",
    "administration.banner.search.form.title": "Formulario de banner",
    "administration.banner.search.table.title": "Resultados de búsqueda",
    "administration.banner.confirm.delete.msg": "¿Desea eliminar el banner ?1?",

    "administration.foto.form.title": "Formulario de foto",
    "administration.foto.form.save.msg.success": "Foto creado correctamente",
    "administration.foto.form.edit.msg.success": "Foto editado correctamente",
    "administration.foto.form.delete.msg.success": "Foto eliminado correctamente",
    "administration.foto.search.form.title": "Formulario de foto",
    "administration.foto.search.table.title": "Resultados de búsqueda",
    "administration.foto.confirm.delete.msg": "¿Desea eliminar el foto ?1?",

    "administration.galeria.form.title": "Formulario de galeria",
    "administration.galeria.form.save.msg.success": "Galeria creado correctamente",
    "administration.galeria.form.edit.msg.success": "Galeria editado correctamente",
    "administration.galeria.form.delete.msg.success": "Galeria eliminado correctamente",
    "administration.galeria.search.form.title": "Formulario de galeria",
    "administration.galeria.search.table.title": "Resultados de búsqueda",
    "administration.galeria.confirm.delete.msg": "¿Desea eliminar el galeria ?1?",

    "administration.habitacion.form.title": "Formulario de habitacion",
    "administration.habitacion.form.save.msg.success": "Habitacion creado correctamente",
    "administration.habitacion.form.edit.msg.success": "Habitacion editado correctamente",
    "administration.habitacion.form.delete.msg.success": "Habitacion eliminado correctamente",
    "administration.habitacion.search.form.title": "Formulario de habitacion",
    "administration.habitacion.search.table.title": "Resultados de búsqueda",
    "administration.habitacion.confirm.delete.msg": "¿Desea eliminar el habitacion ?1?",

    "administration.plan.form.title": "Formulario de plan",
    "administration.plan.form.save.msg.success": "Plan creado correctamente",
    "administration.plan.form.edit.msg.success": "Plan editado correctamente",
    "administration.plan.form.delete.msg.success": "Plan eliminado correctamente",
    "administration.plan.search.form.title": "Formulario de plan",
    "administration.plan.search.table.title": "Resultados de búsqueda",
    "administration.plan.confirm.delete.msg": "¿Desea eliminar el plan ?1?",

    "administration.precio.form.title": "Formulario de precio",
    "administration.precio.form.save.msg.success": "Precio creado correctamente",
    "administration.precio.form.edit.msg.success": "Precio editado correctamente",
    "administration.precio.form.delete.msg.success": "Precio eliminado correctamente",
    "administration.precio.search.form.title": "Formulario de precio",
    "administration.precio.search.table.title": "Resultados de búsqueda",
    "administration.precio.confirm.delete.msg": "¿Desea eliminar el precio ?1?",

    "administration.reserva.form.title": "Formulario de reserva",
    "administration.reserva.form.save.msg.success": "Reserva creado correctamente",
    "administration.reserva.form.edit.msg.success": "Reserva editado correctamente",
    "administration.reserva.form.delete.msg.success": "Reserva eliminado correctamente",
    "administration.reserva.search.form.title": "Formulario de reserva",
    "administration.reserva.search.table.title": "Resultados de búsqueda",
    "administration.reserva.confirm.delete.msg": "¿Desea eliminar el reserva ?1?",

    "administration.tipologia.form.title": "Formulario de tipologia",
    "administration.tipologia.form.save.msg.success": "Tipologia creado correctamente",
    "administration.tipologia.form.edit.msg.success": "Tipologia editado correctamente",
    "administration.tipologia.form.delete.msg.success": "Tipologia eliminado correctamente",
    "administration.tipologia.search.form.title": "Formulario de tipologia",
    "administration.tipologia.search.table.title": "Resultados de búsqueda",
    "administration.tipologia.confirm.delete.msg": "¿Desea eliminar el tipologia ?1?",

    "administration.valor.form.title": "Formulario de valor",
    "administration.valor.form.save.msg.success": "Valor creado correctamente",
    "administration.valor.form.edit.msg.success": "Valor editado correctamente",
    "administration.valor.form.delete.msg.success": "Valor eliminado correctamente",
    "administration.valor.search.form.title": "Formulario de valor",
    "administration.valor.search.table.title": "Resultados de búsqueda",
    "administration.valor.confirm.delete.msg": "¿Desea eliminar el valor ?1?",

    "administration.video.form.title": "Formulario de video",
    "administration.video.form.save.msg.success": "Video creado correctamente",
    "administration.video.form.edit.msg.success": "Video editado correctamente",
    "administration.video.form.delete.msg.success": "Video eliminado correctamente",
    "administration.video.search.form.title": "Formulario de video",
    "administration.video.search.table.title": "Resultados de búsqueda",
    "administration.video.confirm.delete.msg": "¿Desea eliminar el video ?1?",


    "": "",
};



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/util/message.constants.ts